import { render, staticRenderFns } from "./ImportTab.vue?vue&type=template&id=b9bdf51c&scoped=true"
import script from "./ImportTab.vue?vue&type=script&lang=js"
export * from "./ImportTab.vue?vue&type=script&lang=js"
import style0 from "./ImportTab.vue?vue&type=style&index=0&id=b9bdf51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bdf51c",
  null
  
)

export default component.exports